import React from 'react';
import {GetMobileTableStyles} from '../../../styles';
import {View} from 'react-native';
import {Text} from '../../../../../shared/components/text';
import {format} from 'date-fns';
import {dateFormats} from '../../../../../shared/constants/date';
import {ViewProps} from './model';
import {numToPostfix} from '../../../../../shared/utils/text';

export const MobileView = ({data}: ViewProps) => {
  const styles = GetMobileTableStyles();

  return (
    <View style={styles.container}>
      {!data?.length ? (
        <Text style={styles.noData}>Нет данных</Text>
      ) : (
        data.map((item) => (
          <View key={item.date} style={styles.item}>
            <Text style={styles.itemHead} type='body'>
              {item.name}
            </Text>
            <View style={styles.itemBody}>
              <Text type='action'>{`${item.eventHours} ${numToPostfix(item.eventHours, [
                'час',
                'часа',
                'часов',
              ])}`}</Text>
              <Text type='bodySmallLight' style={styles.itemBodyDate}>
                {format(new Date(item.date), dateFormats.fullDate)}
              </Text>
            </View>
          </View>
        ))
      )}
    </View>
  );
};
